import {
  ITennisTourRanking,
  TennisTourRanking,
} from "@sky-it-livedata/livedata-sports-design-system";
import { graphql } from "appsync";
import { useSubscription } from "../../hooks/useSubscription";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";

import { transformQuery } from "./transformers/transformQuery";
import { transformSubscription } from "./transformers/transformSubscription";
import { RankingData, RankingSubscriptionData } from "./types";

export const setCustomAttributes = ({variables}: WidgetContext<RankingData>) => {
  return { variables: JSON.stringify(variables), };
}

const subscriptionDocument = graphql("subscription onUpdateSdapiRankingWidgetByCircuitType($circuitType: ID!) {\n  onUpdateSdapiRankingWidgetByCircuitType(circuitType: $circuitType) {\n    rankings {\n      nationality\n      playerName\n      points\n      rank\n      trend\n    }\n    circuitType\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<RankingData>): ITennisTourRanking {
  return transformQuery(props);
}

export default function Ranking({
  props,
  variables,
  ...rest
}: WidgetContext<ITennisTourRanking>) {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    ITennisTourRanking,
    RankingSubscriptionData,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables: {
      circuitType: variables.circuitType,
    },
    transform: transformSubscription,
    mergeData: false,
  });

  return <TennisTourRanking {...updatedProps} />;
}
